export enum UserRole {
    User = 'User',
  Administrator = 'Administrator',
  SystemAdministrator='System Administrator',
  Management='Management',
  Employee='Employee',
  TeamLead='Team Lead',
  SalesRepresentative='Sales Representative',
  Receptionist='Receptionist',
  Manager='Manager',
  SalesSupport="Sales Support",
  Shipper="Shipper/Receiver",
  Reporter="Reporter",
  PowerUser="Power User",
  SuperUser="Super User",
  Device="Device",
  Signage="Signage"
  
}
